// extracted by mini-css-extract-plugin
export default {"one-quarter-page":"one-quarter-module__one-quarter-page___MPhNR","one-quarter-page--top-menu":"one-quarter-module__one-quarter-page--top-menu___vrJG8"};